import React from "react";
import { makeStyles } from '@material-ui/core/styles';
import InputBase from '@material-ui/core/InputBase';
import IconButton from "@material-ui/core/IconButton";
import searchIcon from "../../images/iconBusqueda.svg"


const useStyles = makeStyles((theme) => ({
  root: {
    border: "1px solid #ddd",
    borderRadius: "2px",
    display: 'flex',
    alignItems: 'center',
    height: 35,
    marginLeft: 5,
    "&:focus-within": {
      borderColor: "#3B5158"
    }
  },
  input: {
    marginLeft: "1px",
    flex: 1,
    fontSize: "12px"
  },
  iconButton: {
    padding: 10,
  },
}));

function SearchInput(props) {

  const classes = useStyles();
  const { onChange, onClick } = props;

  function handleKeydown(e) {
    if (e.keyCode == 13) {
      onClick(e.target.value)
    }
  }

  return (
    <div style={{display:"flex", alignItems:"center"}}>
      <div className={classes.root}  style={{display:"flex", /*width: "145px",*/ backgroundColor: "white"}}>
        <InputBase
          className={classes.input}
          inputProps={{ 'aria-label': 'search' }}
          placeholder={"CNPJ"}
          onChange={onChange}
          onKeyDown={(e) => handleKeydown(e)}
          style={{margin:"10px"}}
        />
        <div  style={{marginLeft:"3px" ,display:"flex"}}>
        <IconButton onClick={onClick} size="medium"><img src={searchIcon} width={20} alt="buscar lead" /></IconButton>
      </div>
      </div>
      
    </div>
  )
}

export { SearchInput }